export default __webpack_public_path__ + "static/media/TagAndTrace_beyaz.802c999a.png";